import type { ReactNode } from "react";

import { toast } from "@/lib/toast";

// TechHint — human-readable value first, technical wire value on demand.
// Hovering reveals the raw value (native tooltip); clicking copies it.
// Used across the crypto Wallet Ops pages where the API speaks in ULIDs,
// base-unit integers, and minor units that operators shouldn't have to
// read directly.
export function TechHint({
  tech,
  children,
  className = "",
}: {
  /** Raw technical value shown on hover and copied on click. */
  tech: string | number | null | undefined;
  children: ReactNode;
  className?: string;
}) {
  const raw = tech === null || tech === undefined ? "" : String(tech);
  if (!raw) return <span className={className}>{children}</span>;
  return (
    <span
      className={`cursor-help decoration-dotted underline-offset-2 hover:underline ${className}`}
      title={raw}
      onClick={(e) => {
        e.stopPropagation();
        void navigator.clipboard?.writeText(raw);
        toast.info("Copied raw value");
      }}
    >
      {children}
    </span>
  );
}
